import { wfWigitModes } from '../../features/workflow/CoordinatorWidget';
import { useWorkflowSocket } from '../../features/workflow/hub/useWorkflowSocket';
import { ManagedUser } from '../../features/workflow/ManagedUser';
import { UserType } from '../../features/workflow/types';

export const QuickAccessUser = (props: {
  onUserDialog: (user: UserType, x: 'status' | 'schedules') => void;
  id: string;
  mode: wfWigitModes;
}) => {
  const user = useWorkflowSocket((r) => r.data?.users?.[props.id]);
  if (user == undefined) {
    return <></>;
  }
  return <ManagedUser onUserDialog={props.onUserDialog} user={user} mode={props.mode} />;
};
